/* cw-pages.js · LIQUID-PAGES v40 (phase 2) · behaviour of the v40 ritual and brand pages (sections/cw-page-*.liquid).
   Faithful port of the approved prototype scripts (prototype/assets/js/pages/{routine-cards,rituali,quiz,idee-regalo,
   brand,brand-forms,newsletter}.js). Classic script, `defer`, loaded by each cw-page section (runs ONCE: guard below).
   Contract with the CORE (prototype/CONTRIBUTING.md): window.CW.{addItems, money, markHTML, announce, openOverlay,
   closeOverlay, cart}; events cart:refresh {cart, source}, cart:added. Routine buttons use the declarative
   data-cw-add-items / data-cw-add-variant (+ data-cw-source) handled ONCE by the core. When window.CW is missing (theme
   before the core merge) a fallback adds with ONE POST /cart/add.js {items, sections:['cart-drawer']}, swaps the drawer,
   emits cart:refresh and opens the drawer (same path as assets/cw-collection.js). Nothing else listens to submit.
   URL state (builder ?m=&f=&s=&r=, quiz answers) keeps every other parameter (view=, preview_theme_id=). */
(function () {
  'use strict';
  if (window.__cwPagesLoaded) return;
  window.__cwPagesLoaded = true;

  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(s)); };
  function CWok(fn) { return window.CW && typeof window.CW[fn] === 'function'; }
  function money(c) {
    if (CWok('money')) return window.CW.money(c);
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format((c || 0) / 100).replace(/\s/g, '').replace(/^(.*?)(€)$/, '€$1'); } catch (e) { return '€' + ((c || 0) / 100).toFixed(2).replace('.', ','); }
  }
  // struck reference of a reduced price (Liquid JSON "c", snippets/cw-disc-price.liquid rule): Omnibus, never alone
  function cmpHTML(v) { return v && v.c ? ' <s class="cw-price__cmp cw-num"><span class="cw-sr">prezzo precedente </span>' + esc(money(v.c)) + '</s>' : ''; }
  var live;
  function announce(msg) {
    if (CWok('announce')) return window.CW.announce(msg);
    if (!live) { live = doc.createElement('p'); live.className = 'cw-sr'; live.setAttribute('aria-live', 'polite'); live.setAttribute('role', 'status'); doc.body.appendChild(live); }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  }
  var MARKS = { '01': ['01', 'Detergere'], '02': ['02', 'Tonificare e trattare'], '03': ['03', 'Nutrire'], '04': ['04', 'Proteggere'], settimana: [null, 'Una volta a settimana'], sguardo: [null, 'Sguardo e labbra'], corpo: [null, 'Corpo e mani'] };
  function markHTML(key) {
    if (CWok('markHTML')) return window.CW.markHTML(key, { compact: true });
    var m = MARKS[key]; if (!m) return '';
    return '<span class="cw-mark cw-mark--compact" data-cw-gesture="' + esc(key) + '"><span class="cw-mark__n' + (m[0] ? '' : ' cw-mark__n--star') + '">' + (m[0] || '✳') + '</span><span class="cw-sr">' + m[1] + '</span></span>';
  }
  function setQuery(own, values) {
    try {
      var p = new URLSearchParams(location.search);
      own.forEach(function (k) { p.delete(k); });
      Object.keys(values || {}).forEach(function (k) { if (values[k] !== '' && values[k] != null) p.set(k, values[k]); });
      var s = p.toString().replace(/%2C/gi, ',').replace(/%2F/gi, '/');
      history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
    } catch (e) { /* ignore */ }
  }

  /* ---- cart: core API, or a single-request fallback --------------------------------------------- */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function swapDrawer(html) {
    if (!html) return;
    try {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
      var current = doc.querySelector('[data-cart-drawer]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    } catch (e) { /* /cart stays reachable */ }
  }
  function addItems(items, o) {
    o = o || {};
    if (CWok('addItems')) return window.CW.addItems(items, o);
    var btn = o.opener;
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: location.pathname }),
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error((d && (d.description || d.message)) || 'add_failed'); return d; });
    }).then(function (d) {
      swapDrawer(d && d.sections && d.sections['cart-drawer']);
      doc.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: o.source || 'routine' } }));
      doc.dispatchEvent(new CustomEvent('cart:added', { detail: { items: items, source: o.source || 'routine' } }));
      announce(items.length === 1 ? 'Prodotto aggiunto al carrello.' : items.length + ' prodotti aggiunti al carrello.');
      if (o.open) { var t = doc.querySelector('[data-cart-drawer-open]'); if (t) t.click(); }
    }).catch(function (err) {
      announce(err && err.message && err.message !== 'add_failed' ? err.message : 'Non siamo riusciti ad aggiungere i prodotti. Riprova tra poco.');
    }).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  // Fallback for the declarative buttons, ONLY while the core API is absent (the core owns them otherwise).
  doc.addEventListener('click', function (e) {
    if (CWok('addItems')) return;
    var b = e.target.closest && e.target.closest('[data-cw-add-items],[data-cw-add-variant]');
    if (!b || b.disabled || !b.closest('.cw-page')) return;
    var items;
    if (b.hasAttribute('data-cw-add-items')) { try { items = JSON.parse(b.getAttribute('data-cw-add-items')); } catch (err) { return; } }
    else items = [{ id: Number(b.getAttribute('data-cw-add-variant')), quantity: 1 }];
    if (!items || !items.length) return;
    e.preventDefault();
    addItems(items, { open: true, source: b.getAttribute('data-cw-source') || 'routine', opener: b });
  });

  /* ---- routine cards: version switch (routine-cards.js) ------------------------------------------- */
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-cw-rc-version]')) return;
    var card = t.closest('[data-cw-rcard]');
    if (!card) return;
    qsa('[data-cw-rc-panel]', card).forEach(function (p) { p.hidden = p.getAttribute('data-cw-rc-panel') !== t.value; });
    announce(t.parentNode.textContent.replace(/\s+/g, ' ').trim());
  });

  /* ---- routine builder (rituali.js) ---------------------------------------------------------------- */
  (function () {
    var rootEl = doc.querySelector('[data-cw-rb]');
    if (!rootEl) return;
    var D;
    try { D = JSON.parse(rootEl.querySelector('[data-cw-rb-data]').textContent); } catch (e) { return; }
    var T = D.T || 0;
    var cartTotal = D.cart || 0;
    var qs = function (s, el) { return (el || rootEl).querySelector(s); };
    var plural = function (n, one, many) { return n + ' ' + (n === 1 ? one : many); };
    var groups = [];
    D.steps.forEach(function (s) { s.groups.forEach(function (g) { g.step = s.k; groups.push(g); }); });
    var groupOf = {};
    groups.forEach(function (g) { g.hs.forEach(function (h) { groupOf[h] = g; }); });
    var state = { m: 'mattina', f: 'pieno', sel: {} };
    groups.forEach(function (g) { state.sel[g.k] = g.def && D.opts[g.def] && D.opts[g.def].full.a ? g.def : ''; });

    function visible(o, g, m) {
      if (g.mo && m === 'sera') return false;
      if (o.m.length === 1 && o.m[0] !== m) return false;
      return true;
    }
    function tag(o, g, m) {
      if (!o.full.a) return 'Esaurito';
      var t;
      if (g.wk) t = o.wk ? 'Una-due volte a settimana, dalla scheda' : 'La scheda non indica la frequenza';
      else if (o.m.indexOf('mattina') > -1 && o.m.indexOf('sera') > -1) t = 'Mattina e sera';
      else if (o.m.length === 1) t = o.m[0] === 'mattina' ? 'Solo al mattino' : 'Solo la sera';
      else t = 'La scheda non indica il momento';
      if (state.f === 'viaggio' && !o.tr) t += ' · solo formato pieno';
      return t;
    }
    function pick(o) { return state.f === 'viaggio' && o.tr && o.tr.a ? o.tr : o.full; }
    function chosen() {
      var out = [];
      groups.forEach(function (g) { var h = state.sel[g.k]; if (h && D.opts[h]) out.push(D.opts[h]); });
      return out;
    }
    function quotesHTML(o) {
      var list = [o.oq, o.mq[state.m], o.mq.settimanale].filter(Boolean);
      var seen = {};
      return list.filter(function (x) { if (seen[x.q]) return false; seen[x.q] = 1; return true; }).slice(0, 2).map(function (x) {
        return '<blockquote class="cw-quote cw-rb__quote">«' + esc(x.q) + '»<cite>dalla scheda prodotto · ' + esc(x.src) + '</cite></blockquote>';
      }).join('') + '<a class="cw-textlink cw-rb__pdp" href="' + esc(o.u) + '">Scheda di ' + esc(o.t) + '</a>';
    }
    function match(list) {
      var key = list.map(function (o) { return o.h; }).sort().join('|');
      for (var k in D.presets) {
        var p = D.presets[k];
        if (p.f !== state.f || (p.m && p.m !== state.m)) continue;
        if (p.hs.slice().sort().join('|') === key) return p.name;
      }
      return '';
    }
    function render(changed) {
      var m = state.m;
      groups.forEach(function (g) {
        var fs = qs('[data-cw-rb-group="' + g.k + '"]');
        if (!fs) return;
        var hidden = [];
        g.hs.forEach(function (h) {
          var o = D.opts[h], lab = qs('[data-cw-rb-opt="' + h + '"]', fs);
          if (!o || !lab) return;
          var vis = visible(o, g, m);
          lab.hidden = !vis;
          if (!vis) hidden.push(o);
          qs('[data-cw-rb-tag]', lab).textContent = tag(o, g, m);
          var v = pick(o);
          qs('[data-cw-rb-fmt]', lab).textContent = v.l;
          qs('[data-cw-rb-price]', lab).innerHTML = esc(money(v.p)) + cmpHTML(v);
        });
        var cur = state.sel[g.k];
        if (cur && (!D.opts[cur] || !visible(D.opts[cur], g, m))) cur = state.sel[g.k] = g.def && g.def !== cur && D.opts[g.def] && D.opts[g.def].full.a && visible(D.opts[g.def], g, m) ? g.def : '';
        qsa('input', fs).forEach(function (i) { i.checked = i.value === (cur || ''); });
        var hint = qs('[data-cw-rb-hint]', fs);
        var msg = '';
        if (g.mo && m === 'sera') msg = 'Le schede delle protezioni solari dicono di applicarle «prima dell\'esposizione»: la sera questo passaggio resta vuoto.';
        else if (hidden.length) msg = hidden.map(function (o) { var q = o.mq.mattina || o.mq.sera; return o.t + ' è pensata per ' + (o.m[0] === 'mattina' ? 'il mattino' : 'la sera') + (q ? ': «' + q.q + '»' : ''); }).join(' ') + '.';
        hint.textContent = msg; hint.hidden = !msg;
        var none = qs('[data-cw-rb-opt=""]', fs);
        if (none) none.hidden = !!(g.mo && m === 'sera');
        if (!changed || changed === g.k || changed === '*') qs('[data-cw-rb-why]', fs).innerHTML = cur ? quotesHTML(D.opts[cur]) : '';
      });
      D.steps.forEach(function (s) {
        var names = s.groups.map(function (g) { var h = state.sel[g.k]; return h && D.opts[h] ? D.opts[h].t : ''; }).filter(Boolean);
        var a = doc.querySelector('[data-cw-rb-navstep="' + s.k + '"]');
        if (!a) return;
        qs('[data-cw-rb-navpick]', a).textContent = names.join(' · ') || 'Nessun prodotto';
        a.classList.toggle('is-done', names.length > 0);
      });
      var list = chosen(), items = [], total = 0;
      var rows = list.map(function (o) {
        var v = pick(o);
        if (v.a) { items.push({ id: v.id, quantity: 1 }); total += v.p; }
        return '<li>' + markHTML(o.g) + '<span class="cw-rb__lname">' + esc(v.t) + (v.l ? ' <small>' + esc(v.l) + '</small>' : '') + '</span><span class="cw-num">' + esc(money(v.p)) + cmpHTML(v) + '</span></li>';
      });
      qs('[data-cw-rb-list]').innerHTML = rows.join('') || '<li class="cw-rb__empty">Nessun prodotto scelto.</li>';
      qs('[data-cw-rb-sumtitle]').innerHTML = m === 'sera' ? 'Della <em>sera</em>' : 'Del <em>mattino</em>';
      var name = match(list), mEl = qs('[data-cw-rb-match]');
      mEl.textContent = name ? 'Coincide con: ' + name + '.' : ''; mEl.hidden = !name;
      var count = plural(items.length, 'prodotto', 'prodotti');
      qs('[data-cw-rb-count]').textContent = count + ' · prezzo dei singoli prodotti';
      qs('[data-cw-rb-total]').textContent = money(total);
      qs('[data-cw-rb-barcount]').textContent = count;
      qs('[data-cw-rb-bartotal]').textContent = money(total);
      qs('[data-cw-rb-btn]').textContent = money(total);
      var ship = qs('[data-cw-rb-ship]');
      if (ship && T > 0) {
        var sum = total + cartTotal;
        qs('[data-cw-rb-shiptext]').textContent = !total ? 'Scegli almeno un prodotto.'
          : sum >= T ? (cartTotal && total < T ? 'Con il tuo carrello e questa routine la spedizione in Italia è gratuita, se il totale dopo eventuali sconti resta da ' + money(T) + '.' : 'Con questa routine la spedizione in Italia è gratuita, se il totale dopo eventuali sconti resta da ' + money(T) + '.')
          : 'Ti mancano ' + money(T - sum) + ' per la spedizione gratuita in Italia.';
        ship.classList.toggle('is-reached', !!total && sum >= T);
        qsa('[data-cw-rb-meter]', rootEl).forEach(function (el) { el.style.transform = 'scaleX(' + Math.min(1, sum / T).toFixed(3) + ')'; });
        var cl = qs('[data-cw-rb-cartline]');
        cl.textContent = cartTotal ? 'Nel carrello hai già ' + money(cartTotal) + ': con questa routine arrivi a ' + money(sum) + '.' : '';
        cl.hidden = !cartTotal;
      }
      qsa('[data-cw-rb-add]', rootEl).forEach(function (b) { b.disabled = !items.length; b.setAttribute('data-items', JSON.stringify(items)); });
      setQuery(['m', 'f', 's', 'r', 'v'], { m: m, f: state.f, s: list.map(function (o) { return o.h; }).join('.') });
      return { items: items, total: total };
    }
    function syncControls() {
      qsa('[data-cw-rb-moment]', rootEl).forEach(function (i) { i.checked = i.value === state.m; });
      qsa('[data-cw-rb-format]', rootEl).forEach(function (i) { i.checked = i.value === state.f; });
      var note = qs('[data-cw-rb-mnote]');
      if (note) note.textContent = state.m === 'sera'
        ? 'La sera mostriamo i prodotti che la indicano nella loro scheda; quelli pensati solo per il mattino escono dalla scelta.'
        : 'Al mattino mostriamo i prodotti che lo indicano nella loro scheda; gli altri hanno la nota «La scheda non indica il momento».';
    }
    function load(preset) {
      var p = D.presets[preset];
      if (!p) return false;
      groups.forEach(function (g) { state.sel[g.k] = ''; });
      p.hs.forEach(function (h) { var g = groupOf[h]; if (g && !state.sel[g.k] && D.opts[h] && D.opts[h].full.a) state.sel[g.k] = h; });
      if (p.m) state.m = p.m;
      state.f = p.f;
      syncControls();
      render('*');
      return true;
    }
    rootEl.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-cw-rb-moment]')) { state.m = t.value; syncControls(); render('*'); announce(t.value === 'sera' ? 'Rituale della sera' : 'Rituale del mattino'); return; }
      if (t.matches('[data-cw-rb-format]')) { state.f = t.value; render('*'); announce(t.value === 'viaggio' ? 'Formato da viaggio' : 'Formato pieno'); return; }
      var fs = t.closest('[data-cw-rb-group]');
      if (fs && t.type === 'radio') {
        var g = fs.getAttribute('data-cw-rb-group');
        state.sel[g] = t.value;
        var r = render(g);
        announce('Totale ' + money(r.total));
      }
    });
    rootEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cw-rb-add]');
      if (!b || b.disabled) return;
      var items = JSON.parse(b.getAttribute('data-items') || '[]');
      if (!items.length) return;
      b.setAttribute('aria-busy', 'true');
      addItems(items, { open: true, source: 'ritual-builder', opener: b });   // ONE call for the whole routine
      setTimeout(function () { b.removeAttribute('aria-busy'); }, 300);
    });
    doc.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-cw-rb-load]');
      if (!b) return;
      var card = b.closest('[data-cw-rcard]');
      var v = card && card.querySelector('[data-cw-rc-version]:checked');
      var panel = card && card.querySelector('[data-cw-rc-panel]');
      var key = b.getAttribute('data-cw-rb-load') + '/' + (v ? v.value : panel ? panel.getAttribute('data-cw-rc-panel') : '');
      if (!load(key)) return;
      var head = doc.getElementById('rb-title');
      rootEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
      announce('Routine caricata nel costruttore: ' + D.presets[key].name);
    });
    doc.addEventListener('cart:refresh', function (e) {
      var c = e.detail && e.detail.cart;
      if (c && typeof c.total_price === 'number') { cartTotal = c.total_price; render('none'); return; }
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (cart) { cartTotal = cart.total_price || 0; render('none'); }).catch(function () { /* keep the last total */ });
    });
    var bar = qs('[data-cw-rb-bar]'), sumBtn = qs('.cw-rb__sum [data-cw-rb-add]');
    if (bar && sumBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('is-away', en[0].isIntersecting); }).observe(sumBtn);
    }
    var P = new URLSearchParams(location.search);
    var r = P.get('r');
    var keys = Object.keys(D.presets);
    var preset = r && (D.presets[r] ? r : D.presets[r + '/' + (P.get('v') || '')] ? r + '/' + P.get('v') : keys.filter(function (k) { return k.indexOf(r + '/') === 0; })[0]);
    if (preset) load(preset);
    else {
      if (P.get('m') === 'sera') state.m = 'sera';
      if (P.get('f') === 'viaggio') state.f = 'viaggio';
      if (P.has('s')) {
        groups.forEach(function (g) { state.sel[g.k] = ''; });
        P.get('s').split('.').forEach(function (h) { var g = groupOf[h]; if (g && D.opts[h] && D.opts[h].full.a && !state.sel[g.k]) state.sel[g.k] = h; });
      }
      syncControls();
      render('*');
    }
    rootEl.classList.add('is-ready');
  })();

  /* ---- quiz (quiz.js) ------------------------------------------------------------------------------ */
  (function () {
    var rootEl = doc.querySelector('[data-cw-quiz]');
    if (!rootEl) return;
    var D;
    try { D = JSON.parse(rootEl.querySelector('[data-cw-quiz-data]').textContent); } catch (e) { return; }
    var form = rootEl.querySelector('[data-cw-quiz-form]');
    var qsets = qsa('[data-cw-quiz-q]', form);
    var N = qsets.length, cur = 0;
    var back = form.querySelector('[data-cw-quiz-back]'), next = form.querySelector('[data-cw-quiz-next]');
    var res = rootEl.querySelector('[data-cw-quiz-result]');
    var KEYS = qsets.map(function (f) { return f.getAttribute('data-cw-quiz-q'); });
    function val(k) { var i = form.querySelector('input[name="' + k + '"]:checked'); return i ? i.value : ''; }
    function answers() { var a = {}; KEYS.forEach(function (k) { a[k] = val(k); }); return a; }
    function show(i, focus) {
      cur = i;
      qsets.forEach(function (f, k) { f.hidden = k !== i; });
      back.hidden = i === 0;
      next.textContent = i === N - 1 ? 'Scopri il tuo rituale' : 'Avanti';
      form.querySelector('[data-cw-quiz-count]').textContent = 'Domanda ' + (i + 1) + ' di ' + N;
      var pb = form.querySelector('[data-cw-quiz-progress]');
      pb.setAttribute('aria-valuenow', i + 1); pb.setAttribute('aria-valuetext', 'Domanda ' + (i + 1) + ' di ' + N);
      pb.firstElementChild.style.transform = 'scaleX(' + ((i + 1) / N).toFixed(3) + ')';
      if (focus) {
        var t = qsets[i].querySelector('[data-cw-quiz-title]');
        t.focus({ preventScroll: true });
        var top = form.getBoundingClientRect().top + scrollY - 110;
        if (scrollY > top) scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        announce('Domanda ' + (i + 1) + ' di ' + N + ': ' + t.textContent);
      }
    }
    // answers -> real routine (ROUTINES.md) + one optional extra product (same mapping as the prototype)
    function resolve(a) {
      var k;
      if (a.goal === 'corpo') k = a.budget === 'sotto' ? 'viaggio/corpo' : 'corpo/base';
      else if (a.goal === 'maschera') k = 'multimasking/base';
      else if (a.goal === 'viaggio' || a.budget === 'sotto') k = 'viaggio/viso';
      else if (a.goal === 'inizio') {
        if (a.need === 'imperfezioni') k = a.moment === 'sera' ? 'essenziale/diva' : 'essenziale/impura';
        else k = a.texture === 'mousse' ? 'essenziale/diva' : 'essenziale/creamy';
      } else {
        if (a.moment === 'mattina') k = a.need === 'imperfezioni' ? 'mattina/mattificante' : a.texture === 'latte' ? 'mattina/creamy' : 'mattina/soft';
        else if (a.moment === 'sera') k = a.need === 'nutrimento' ? 'sera/soft' : 'sera/filler';
        else k = 'completo/quotidiano';
      }
      var r = D.results[k];
      var pool = a.goal === 'corpo' ? { nutrimento: 'clap-clap' } : a.goal === 'maschera' ? { idratazione: 'hyalu-mask', imperfezioni: 'purify-mask' } : { idratazione: 'hyalu-mask', imperfezioni: 'purify-mask', nutrimento: 'shiny', detersione: 'shake-it-off' };
      var x = pool[a.need];
      if (x && (!D.prods[x] || (r && r.hs.indexOf(x) > -1))) x = '';
      return { key: k, r: r, extra: x || '' };
    }
    function quoteFor(h, a) {
      var p = D.prods[h];
      if (!p) return null;
      var mom = a.moment === 'entrambi' ? 'mattina' : a.moment;
      if (p.needs[a.need]) return { why: 'Per ' + D.labels.need[a.need].toLowerCase(), q: p.needs[a.need] };
      if (a.goal !== 'corpo' && p.mom[mom]) return { why: a.moment === 'sera' ? 'Per la sera' : a.moment === 'entrambi' ? 'Mattina e sera' : 'Per il mattino', q: p.mom[mom] };
      if (p.oq) return { why: p.pair ? 'Abbinato' : 'Nell\'ordine giusto', q: p.oq };
      if (p.mom.settimanale) return { why: 'Una volta a settimana', q: p.mom.settimanale };
      return null;
    }
    function render(a) {
      var o = resolve(a), r = o.r, T = D.T;
      if (!r) return false;
      qsa('[data-cw-quiz-card]', rootEl).forEach(function (c) { c.hidden = c.getAttribute('data-cw-quiz-card') !== o.key; });
      qsa('[data-cw-quiz-extra]', rootEl).forEach(function (c) { c.hidden = c.getAttribute('data-cw-quiz-extra') !== o.extra; });
      rootEl.querySelector('[data-cw-quiz-extrawrap]').hidden = !o.extra || !rootEl.querySelector('[data-cw-quiz-extra="' + o.extra + '"]');
      res.querySelector('[data-cw-quiz-rtitle]').textContent = r.name;
      res.querySelector('[data-cw-quiz-answers]').innerHTML = KEYS.map(function (k) { return '<li>' + esc(D.labels[k][a[k]]) + '</li>'; }).join('');
      var intro = {
        inizio: 'Hai scelto pochi gesti: questa è la routine più breve, nell\'ordine scritto nelle schede.',
        completa: 'Hai scelto una routine completa: ogni passaggio ha il suo posto, dichiarato nelle schede.',
        maschera: 'Hai scelto un trattamento in più: due maschere in stick che si nominano a vicenda.',
        corpo: 'Hai scelto il corpo: prima lo scrub, poi il burro.',
        viaggio: 'Hai scelto di provare in piccolo: gli stessi gesti, in formato da viaggio.',
      }[a.goal];
      if (a.goal !== 'viaggio' && a.goal !== 'corpo' && a.budget === 'sotto' && o.key.indexOf('viaggio/') === 0) intro += ' Sotto ' + money(T) + ' ti proponiamo i formati da viaggio.';
      if (a.goal === 'corpo' && a.budget === 'sotto') intro += ' Sotto ' + money(T) + ': i due formati da viaggio per il corpo.';
      res.querySelector('[data-cw-quiz-intro]').textContent = intro;
      var card = rootEl.querySelector('[data-cw-quiz-card="' + o.key + '"]');
      var lis = card ? card.querySelectorAll('.cw-rc__step') : [];
      r.hs.forEach(function (h, i) {
        var li = lis[i]; if (!li) return;
        var body = li.querySelector('.cw-rc__sbody');
        var old = body.querySelector('[data-cw-quiz-wy]'); if (old) old.parentNode.removeChild(old);
        var q = quoteFor(h, a);
        if (!q) return;
        var w = doc.createElement('div');
        w.setAttribute('data-cw-quiz-wy', '');
        w.className = 'cw-quiz__wy';
        w.innerHTML = '<p class="cw-quiz__wk">' + esc(q.why) + '</p><p class="cw-rc__quote">«' + esc(q.q.q) + '» <cite>dalla scheda · ' + esc(q.q.src) + '</cite></p>';
        body.appendChild(w);
      });
      var notes = [];
      if (a.need === 'imperfezioni' && a.moment === 'sera' && a.goal === 'inizio') notes.push('Crema Mattificante, la crema per pelle mista e impura, è pensata per il mattino: per la sera ti proponiamo Crema Soft.');
      if (a.texture !== 'indifferente' && (a.goal === 'corpo' || a.goal === 'maschera')) notes.push('La texture del detergente non conta per questa routine.');
      // real Shopify Bundles product: the card shows its own price = paid (data-cw-bundle-price="singles sum|paid|pct")
      var bpe = card && card.querySelector('[data-cw-bundle-price]');
      var tot = bpe ? (Number(bpe.getAttribute('data-cw-bundle-price').split('|')[1]) || r.total) : r.total;
      if (tot < T) notes.push('Totale ' + money(tot) + ': per la spedizione gratuita in Italia mancano ' + money(T - tot) + '.' + (o.extra && tot + D.prods[o.extra].p >= T ? ' Con ' + D.prods[o.extra].t + ' ci arrivi.' : ''));
      var note = res.querySelector('[data-cw-quiz-note]');
      note.textContent = notes.join(' '); note.hidden = !notes.length;
      if (o.extra) {
        var xp = D.prods[o.extra], xq = xp.needs[a.need] || xp.mom.settimanale || xp.oq;
        var el = rootEl.querySelector('[data-cw-quiz-extra="' + o.extra + '"] [data-cw-quiz-xquote]');
        if (el) el.innerHTML = xq ? '«' + esc(xq.q) + '» <cite>' + esc(xq.src) + '</cite>' : '';
      }
      var col = a.goal === 'corpo' ? 'corpo' : a.goal === 'viaggio' ? 'viaggio' : a.goal === 'maschera' ? 'maschera' : a.need;
      var cl = res.querySelector('[data-cw-quiz-col]');
      if (D.cols[col]) cl.href = D.cols[col];
      cl.textContent = a.goal === 'corpo' ? 'Tutto il corpo e mani' : a.goal === 'viaggio' ? 'Tutti i formati da viaggio' : a.goal === 'maschera' ? 'Tutte le maschere e gli scrub' : 'Tutti i prodotti per ' + D.labels.need[a.need].toLowerCase();
      return true;
    }
    function finish(focus) {
      var a = answers();
      if (!render(a)) return;
      form.hidden = true;
      res.hidden = false;
      doc.documentElement.classList.add('cw-quiz-done');
      setQuery(KEYS, a);
      if (focus) {
        var t = res.querySelector('[data-cw-quiz-rtitle]');
        res.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        t.focus({ preventScroll: true });
        announce('Il tuo rituale: ' + t.textContent);
      }
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = qsets[cur], k = f.getAttribute('data-cw-quiz-q'), err = f.querySelector('[data-cw-quiz-err]');
      if (!val(k)) {
        err.hidden = false;
        f.setAttribute('aria-describedby', 'qh-' + k + ' qe-' + k);
        var first = f.querySelector('input'); if (first) first.focus();
        announce('Scegli una risposta per continuare.');
        return;
      }
      err.hidden = true; f.setAttribute('aria-describedby', 'qh-' + k);
      if (cur < N - 1) show(cur + 1, true); else finish(true);
    });
    form.addEventListener('change', function (e) {
      var f = e.target.closest('[data-cw-quiz-q]');
      if (f) f.querySelector('[data-cw-quiz-err]').hidden = true;
    });
    back.addEventListener('click', function () { if (cur > 0) show(cur - 1, true); });
    res.querySelector('[data-cw-quiz-restart]').addEventListener('click', function () {
      form.reset(); res.hidden = true; form.hidden = false;
      doc.documentElement.classList.remove('cw-quiz-done');
      setQuery(KEYS, {});
      show(0, true);
    });
    var P = new URLSearchParams(location.search), ok = true;
    qsets.forEach(function (f) {
      var k = f.getAttribute('data-cw-quiz-q'), v = P.get(k);
      var i = v && f.querySelector('input[value="' + v.replace(/[^a-z]/g, '') + '"]');
      if (i) i.checked = true; else ok = false;
    });
    if (ok) finish(false); else show(0, false);
  })();

  /* ---- gift rails: arrows (idee-regalo.js) ---------------------------------------------------------- */
  (function () {
    var rails = qsa('.cw-gb__rail[id]');
    if (!rails.length) return;
    function state(rail) {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      qsa('[data-cw-gb-dir][aria-controls="' + rail.id + '"]').forEach(function (b) {
        b.disabled = Number(b.getAttribute('data-cw-gb-dir')) < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max;
      });
    }
    doc.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-cw-gb-dir]');
      if (!b) return;
      var rail = doc.getElementById(b.getAttribute('aria-controls'));
      if (rail) rail.scrollBy({ left: Number(b.getAttribute('data-cw-gb-dir')) * rail.clientWidth * 0.75, behavior: reduce ? 'auto' : 'smooth' });
    });
    rails.forEach(function (r) {
      var t;
      r.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { state(r); }, 60); }, { passive: true });
      state(r);
    });
    window.addEventListener('resize', function () { rails.forEach(state); });
  })();

  /* ---- Illustrator thread tracing (brand.js): fail-safe watchdog 1.2 s, reduced motion = drawn ----- */
  (function () {
    var els = qsa('[data-bw-trace]');
    if (!els.length || !('IntersectionObserver' in window) || reduce) return;
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      fired = true;
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-traced'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    doc.documentElement.classList.add('bw-trace-ready');
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { if (!fired) { els.forEach(function (el) { el.classList.add('is-traced'); }); io.disconnect(); } }, 1200);
  })();

  /* ---- consent-first signup forms (brand-forms.js, now REAL Shopify customer forms) -----------------
     Client-side gate only: invalid e-mail or missing consent -> message + focus, no submit. Valid -> the native
     submit goes on (Shopify creates/updates the customer: never in tests). */
  (function () {
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    qsa('[data-bw-form-wrap] form').forEach(function (f) { f.setAttribute('novalidate', ''); });
    doc.addEventListener('submit', function (e) {
      var wrap = e.target.closest && e.target.closest('[data-bw-form-wrap]');
      if (!wrap) return;
      var form = e.target;
      var msg = wrap.querySelector('[data-bw-msg]');
      var input = form.querySelector('input[type="email"]');
      var box = form.querySelector('input[type="checkbox"]');
      if (!input || !box) return;
      var okMail = EMAIL.test((input.value || '').trim());
      input.setAttribute('aria-invalid', String(!okMail));
      box.setAttribute('aria-invalid', String(okMail && !box.checked));
      if (!okMail || !box.checked) {
        e.preventDefault();
        msg.className = 'bw-form__msg is-error';
        if (!okMail) { msg.textContent = 'Controlla l\'indirizzo email e riprova.'; input.focus(); }
        else { msg.textContent = 'Per iscriverti serve il tuo consenso: spunta la casella qui sopra.'; box.focus(); }
        return;
      }
      msg.className = 'bw-form__msg'; msg.textContent = '';
      if (wrap.getAttribute('data-list') === 'letter') { try { localStorage.setItem('cw_nl', JSON.stringify({ s: 'subscribed', t: Date.now() })); } catch (err) { /* private mode */ } }
    });
    // after a successful post the welcome state is focused once (server render)
    var done = qsa('[data-bw-done]').filter(function (d) { return !d.hidden && !d.classList.contains('is-already'); })[0];
    if (done && /customer_posted=true/.test(location.search + location.hash)) { try { done.focus(); } catch (e) { /* ignore */ } }
  })();

  /* ---- Newsletter page: variant switch (review mode), browser state, popup preview (newsletter.js) ---- */
  (function () {
    var pop = doc.querySelector('[data-bw-pop]');
    var out = doc.querySelector('[data-bw-pop-state]');
    if (!pop && !out) return;
    var DAY = 864e5, CAP = 14 * DAY, KEY = 'cw_nl';
    function get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
    function set(s) { try { localStorage.setItem(KEY, JSON.stringify({ s: s, t: Date.now() })); } catch (e) { /* private mode */ } }
    var params; try { params = new URLSearchParams(location.search); } catch (e) { params = { get: function () { return null; } }; }
    var offerDemo = params.get('offerta') === 'demo' && !!doc.querySelector('[data-bw-variant]');
    var offerBlocks = qsa('[data-bw-copy="offer"]');
    if (offerDemo && offerBlocks.length) {
      qsa('[data-bw-copy="neutral"]').forEach(function (el) { el.hidden = true; });
      offerBlocks.forEach(function (el) { el.hidden = false; });
      qsa('[aria-labelledby]').forEach(function (host) {
        var id = host.getAttribute('aria-labelledby'), alt = doc.getElementById(id + '-offer');
        if (alt) host.setAttribute('aria-labelledby', alt.id);
      });
    }
    qsa('[data-bw-variant]').forEach(function (a) {
      var isOffer = a.getAttribute('data-bw-variant') === 'offer';
      try {
        var p = new URLSearchParams(location.search);
        if (isOffer) p.set('offerta', 'demo'); else p.delete('offerta');
        var s = p.toString();
        a.setAttribute('href', location.pathname + (s ? '?' + s : ''));
      } catch (e) { /* keep the server href */ }
      if (isOffer === offerDemo) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
    var fmt = function (t) { try { return new Date(t).toLocaleDateString('it-IT', { day: 'numeric', month: 'long' }); } catch (e) { return ''; } };
    function renderState() {
      if (!out) return;
      var st = get();
      if (st && st.s === 'subscribed') out.textContent = 'Iscritta: il popup non si aprirà più in questo browser.';
      else if (st && st.s === 'dismissed' && Date.now() - st.t < CAP) out.textContent = 'Popup chiuso il ' + fmt(st.t) + ': non si riapre prima del ' + fmt(st.t + CAP) + '.';
      else out.textContent = 'Nessuna scelta registrata: il popup si apre dopo metà pagina o dopo 25 secondi.';
    }
    renderState();
    if (!pop) return;
    var card = pop.querySelector('.cw-dialog__card');
    var opener = null, releaseTrap = null;
    function onClose() { var s = get(); if (!s || s.s !== 'subscribed') set('dismissed'); renderState(); }
    function closeFallback() {
      pop.hidden = true;
      doc.documentElement.classList.remove('cw-pg-lock');
      doc.removeEventListener('keydown', onKey);
      if (releaseTrap) { releaseTrap(); releaseTrap = null; }
      onClose();
      if (opener) opener.focus();
    }
    function onKey(e) { if (e.key === 'Escape') closeFallback(); }
    function open(btn) {
      opener = btn || null;
      if (CWok('openOverlay')) { window.CW.openOverlay(pop, { opener: opener, focus: card, onClose: onClose }); return; }
      pop.hidden = false;
      doc.documentElement.classList.add('cw-pg-lock');
      doc.addEventListener('keydown', onKey);
      if (CWok('trapFocus')) releaseTrap = window.CW.trapFocus(card, card);
      card.focus();
    }
    doc.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bw-pop-preview],[data-bw-reset],[data-bw-pop-close]');
      if (!t) return;
      if (t.hasAttribute('data-bw-reset')) { try { localStorage.removeItem(KEY); sessionStorage.removeItem(KEY); } catch (err) { /* ignore */ } renderState(); announce('Stato azzerato.'); return; }
      if (t.hasAttribute('data-bw-pop-close')) { if (!CWok('openOverlay') && !pop.hidden) closeFallback(); return; }
      open(t);
    });
  })();
})();
